/**
 * Created by daniel.gonzalez on 6/12/15.
 */

'use strict';

var _ = require('underscore');

function addMATGAParams(config, link) {
    var paramsObj = config.ga;
    var params = [];

    _.each(paramsObj, function (value, key) {
        params.push(key + '=' + value);
    });

    params = params.join('&');

    if (link.indexOf('?') !== -1) {
        link += '&' + params;
    } else {
        link += '?' + params;
    }

    return link;
}

function createMATTrackingParams(config, invokeUrl) {
    var paramsObj = _.extend({invoke_url: invokeUrl}, config.params);
    var params = [];
    var link;
    var qp;

    _.each(paramsObj, function (value, key) {
        if (key === 'invoke_url') {
            link = addMATGAParams(config, value);
            link = encodeURIComponent(link);
            qp = key + '=' + link;
        } else {
            qp = key + '=' + value;
        }

        params.push(qp);
    });

    return params.join('&');
}

module.exports = {
    createMATTrackingLink: function (config, invokeUrl) {
        var protocol = config.protocol;
        var base = config.base;
        var params = createMATTrackingParams(config, invokeUrl);

        return protocol + base + '?' + params;
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mobileAds/helpers/matLink.js
// module id = 2563
// module chunks = 62